<div mat-dialog-content>
	<div class="flex-column">
		<mat-form-field>
			<mat-label>Name</mat-label>
			<input matInput type="text" [(ngModel)]="name"/>
		</mat-form-field>
		<div class="flex mt-15">
			<mat-label>Color:</mat-label>
			<input type="color" class="colour-box" [(ngModel)]="color" />
		</div>
	</div>
</div>
<div mat-dialog-actions>
	<button mat-button (click)="cancel()">Cancel</button>
	<button mat-button [disabled]="!valid()" (click)="save()">Save</button>
</div>
